/**模板*/
export enum CERTIFICATE_TEMPLATE {
  CAMP = 'CertificateCamp',
  CAMP_2 = 'CertificateCamp2'
}

/**可用模板列表*/
export const CERTIFICATE_TEMPLATE_MAP = [
  {name: '5天短期集训证书', template: CERTIFICATE_TEMPLATE.CAMP},
  {name: '5天短期集训证书(全天)', template: CERTIFICATE_TEMPLATE.CAMP_2},
];

/**难度*/
export enum CERTIFICATE_LEVEL {
  芭蕾入门 = 1,
  初级预备 = 2,
  初级芭蕾 = 3,
  中级预备 = 4,
  中级芭蕾 = 5,
  中级提升 = 6
}


/**难度列表*/
export const CERTIFICATE_LEVEL_MAP = [
  {title: '-空-', label: 'XXXX', key: 0},
  {title: '芭蕾入门', label: 'Entry-level', key: 1},
  {title: '初级预备', label: 'Beginner level', key: 2},
  {title: '初级芭蕾', label: 'Beginner level II', key: 3},
  {title: '中级预备', label: 'Intermediate Ievel', key: 4},
  {title: '中级芭蕾', label: 'Intermediate Ievel II', key: 5},
  {title: '中级提升', label: 'Intermediate Ievel III', key: 6},
  // 自定义
  {title: '芭蕾入门集训', label: 'Entry-level', key: 7},
  {title: '芭蕾入门剧目集训', label: 'Entry-level', key: 8},
  {title: '初级预备芭蕾集训', label: 'Beginner level', key: 9},
  {title: '初级预备剧目集训', label: 'Beginner level', key: 10},
  {title: '初级芭蕾集训', label: 'Beginner level II', key: 11},
  {title: '初级芭蕾变奏集训', label: 'Beginner level II', key: 12},
  {title: '中级芭蕾集训', label: 'Intermediate Ievel II', key: 13}
];
